import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/cibolo")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Cibolo, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Cibolo & Guadalupe County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Cibolo, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Cibolo and Guadalupe County.",
      keywords: "awnings Cibolo, awning company Cibolo, custom awnings Cibolo, sail shades Cibolo, patio covers Cibolo, pergola covers Cibolo, metal awnings Cibolo, canvas awnings Cibolo, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Cibolo", "Guadalupe County"),
  }),
  component: () => <CityHomePage city="Cibolo" region="Guadalupe County" />,
});
